import { render } from "./AreaScreenBarChart.vue?vue&type=template&id=0db7546d&scoped=true"
import script from "./AreaScreenBarChart.vue?vue&type=script&lang=js"
export * from "./AreaScreenBarChart.vue?vue&type=script&lang=js"

import "./AreaScreenBarChart.vue?vue&type=style&index=0&id=0db7546d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db7546d"]])

export default __exports__